import React from "react";
import PropTypes from "prop-types";
import ModalBottom from "../ModalBottom/ModalBottom";
import BlackFridayRange from "../../../js/components/organisms/BlackFridayRange";

const ModalDynamicBonus = ({ show, onClose, onConfirm, ...props }) => {
	return (
		<ModalBottom
			show={show}
			close={onClose}
			fixed
			description={<BlackFridayRange {...props} mobile={true} />}
			confirm="Salvar"
			onConfirm={onConfirm}
			className="modal-dynamic-range"
		/>
	);
};

ModalDynamicBonus.propTypes = {
	show: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired
};

export default ModalDynamicBonus;
